// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cols-map[data-v-2bec77f1]{display:flex;padding:10px 0}.cols-map__hint[data-v-2bec77f1]{color:#ff8a00;font-weight:700}.cols-map[data-v-2bec77f1] .v-chip{border-radius:8px;padding:0 7px;font-size:.69rem;height:22px}.cols-map[data-v-2bec77f1] .e-link{font-size:.59rem!important}", ""]);
// Exports
module.exports = exports;
